export const MOMENT_DATE_FORMAT_DISPLAY = 'D.M.YYYY';
export const MOMENT_DATETIME_FORMAT_DISPLAY = 'D.M.YYYY, HH:mm';
export const MOMENT_DATE_FORMAT_CURRENT = 'YYYY-MM-DDTHH:mm:ss.SSSZZ';
export const MOMENT_DATE_FORMAT_ZERO_SECONDS = 'YYYY-MM-DDTHH:mm:00.000ZZ';
export const MOMENT_DATETIME_FORMAT_DISPLAY_SECONDS = 'D.M.YYYY HH:mm:ss';
export const MOMENT_DATE_FILTER_QUERY = 'YYYY-MM-DD';
